import React from 'react';

function renderElement(elem, index) {
    return (
        <li key={index} className="dropdown--menu__item">
            {elem.content}
        </li>
    );
}

export default class extends React.Component {
    static propTypes = {
        cssClass: React.PropTypes.string.isRequired,
        title: React.PropTypes.object.isRequired,
        elements: React.PropTypes.array.isRequired,
        onClosing: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onDocumentClick = this._onDocumentClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this._onDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onDocumentClick);
    }

    _onDocumentClick() {
        document.removeEventListener('click', this._onDocumentClick);

        this.props.onClosing();
    }

    render() {
        const {cssClass, title, elements} = this.props;

        const cls = 'dropdown--menu ' + cssClass + ' dropdown--menu__shown';

        return (
            <ul className={cls}>
                <li className="title dropdown--menu__title dropdown--menu__item">
                    <span className="dropdown--menu__span">
                        {title}
                    </span>
                </li>
                {elements.filter(s => Boolean(s)).map(renderElement)}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/DropDownMenu.jsx